import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { Trans } from "@lingui/react";
import { i18n } from "@lingui/core";
import React from 'react';
import { Link } from 'gatsby';
import './index.scss';
import SEO from '../components/seo';
import { getAllLocaleUtils } from '../hooks/i18n-hook';
import Button from '../components/shared/form-elements/button/button';
import Icon from '../components/shared/ui-elements/icon/icon';
import Ticker from '../components/shared/ui-elements/ticker/ticker';

var HomePage = function HomePage(_ref) {
  var data = _ref.data,
      props = _objectWithoutPropertiesLoose(_ref, ["data"]);

  console.log({
    data: data,
    props: props
  });

  var _getAllLocaleUtils = getAllLocaleUtils(),
      i18n = _getAllLocaleUtils.i18n,
      locale = _getAllLocaleUtils.locale;

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SEO, {
    title: i18n._(
    /*i18n*/
    i18n._("Home")),
    lang: locale
  }), /*#__PURE__*/React.createElement("div", {
    className: "home-page"
  }, /*#__PURE__*/React.createElement("div", {
    className: "home-page__box"
  }, /*#__PURE__*/React.createElement("div", {
    className: "home-page__left-box"
  }, /*#__PURE__*/React.createElement("h3", null, i18n._(
  /*i18n*/
  i18n._("private lesson"))), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, i18n._(
  /*i18n*/
  i18n._("Price: $10/h"))), /*#__PURE__*/React.createElement("li", null, i18n._(
  /*i18n*/
  i18n._("Duration: 2hours"))), /*#__PURE__*/React.createElement("li", null, i18n._(
  /*i18n*/
  i18n._("Location: TBD"))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Link, {
    to: "./about#lesson-details"
  }, i18n._(
  /*i18n*/
  i18n._("Details about our lesson"))), /*#__PURE__*/React.createElement(Icon, {
    width: 20,
    height: 20,
    id: "icon-arrow"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "home-page__right-box"
  }, /*#__PURE__*/React.createElement(Button, {
    to: "./contact"
  }, i18n._(
  /*i18n*/
  i18n._("contact us")))))), /*#__PURE__*/React.createElement(Ticker, null, /*#__PURE__*/React.createElement(Trans, {
    id: "<0>Hi there, I'm Kento. If you're interested in my lesson or have any questions, feel free to reach me out!</0>",
    components: {
      0: /*#__PURE__*/React.createElement("p", null)
    }
  })));
};

export default HomePage;